import styled from '@emotion/styled'
import React, { useEffect } from 'react'
import Image from 'next/image'
import fitty from 'fitty'
import { Sex } from '@/firebase/firestore/Sex'
import { mapAmoungUsCreatorInfo } from '../config'

export type AmongUsPlayStyle = 'beginner' | 'enjoy' | 'serious'

type Props = {
  targetId: string
  previewImage: string
  fontFamily: string
  fontColor: string
  name: string
  sex: Sex
  platform: Array<0 | 3 | 4>
  voiceChat: Array<0 | 1 | 3 | 4 | 100>
  playStyle: string
  playTimeWeekDayBegin: string
  playTimeWeekDayEnd: string
  playTimeWeekEndBegin: string
  playTimeWeekEndEnd: string
  hitokoto: string
}

/* ぴらちさんカード */
export const AmongUs1: React.FC<Props> = ({
  targetId,
  previewImage,
  fontFamily,
  fontColor,
  name,
  sex,
  playStyle,
  platform,
  voiceChat,
  playTimeWeekDayBegin,
  playTimeWeekDayEnd,
  playTimeWeekEndBegin,
  playTimeWeekEndEnd,
  hitokoto,
}) => {
  useEffect(() => {
    fitty('#name', {
      maxSize: 24,
      minSize: 18,
    })
    fitty('#hitokoto', {
      maxSize: 18,
      minSize: 14,
    })
  }, [])
  return (
    <Container id={targetId} fontFamily={fontFamily} fontColor={fontColor}>
      <Image
        width="713"
        height="428"
        priority={true}
        unoptimized={true}
        alt={'AmongUsプロフィール'}
        src={mapAmoungUsCreatorInfo.pira.profileCardImageURL}
      />
      <PreviewImage src={previewImage} />
      <Name>
        <span id="name">{name}</span>
      </Name>
      <PlayTimeWeekDay>
        平日 {playTimeWeekDayBegin}時〜{playTimeWeekDayEnd}時
      </PlayTimeWeekDay>
      <PlayTimeWeekEnd>
        休日 {playTimeWeekEndBegin}時〜{playTimeWeekEndEnd}時
      </PlayTimeWeekEnd>
      <Hitokoto>
        <span id="hitokoto">{hitokoto}</span>
      </Hitokoto>
      <SexDiv>
        {sex === 0 && '♂'}
        {sex === 1 && '♀'}
        {sex === 2 && ''}
      </SexDiv>
      {platform.includes(0) && <Device2 />}
      {platform.includes(3) && <Device4 />}
      {platform.includes(4) && <Device0 />}
      {(voiceChat.includes(0) ||
        voiceChat.includes(1) ||
        voiceChat.includes(3)) && <VCOk />}
      {voiceChat.includes(0) && <VCSkype />}
      {voiceChat.includes(4) && <VCNg />}
      {voiceChat.includes(100) && <VCCaseBy />}
      {voiceChat.includes(0) && <VCSkype />}
      {voiceChat.includes(1) && <VCLine />}
      {voiceChat.includes(3) && <VCDiscord />}
      {playStyle === 'beginner' && <PlayStyleBeginner />}
      {playStyle === 'enjoy' && <PlayStyleEnjoy />}
      {playStyle === 'serious' && <PlayStyleSerious />}
    </Container>
  )
}

const Container = styled.div<{ fontFamily: string; fontColor: string }>`
  position: relative;
  width: 100%;
  line-height: 0;
  * {
    line-height: 1;
    font-family: ${({ fontFamily }) => fontFamily};
    color: ${({ fontColor }) => fontColor};
    border-color: ${({ fontColor }) => fontColor};
  }
`

const PreviewImage = styled.img`
  position: absolute;
  top: 68.5%;
  left: 58.5%;
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 50%;
  overflow: hidden;
`

const Name = styled.span`
  position: absolute;
  top: 28%;
  left: 7%;
  width: 18%;
  height: 12%;
  word-break: break-all;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-weight: bold;
    text-align: center;
    line-height: 9px;
  }
`

const PlayTimeWeekDay = styled.span`
  position: absolute;
  top: 49%;
  left: 12%;
  font-size: 12px;
  font-weight: bold;
`

const PlayTimeWeekEnd = styled.span`
  position: absolute;
  top: 54%;
  left: 12%;
  font-size: 12px;
  font-weight: bold;
`
const Hitokoto = styled.span`
  position: absolute;
  top: 29%;
  left: 65%;
  width: 25%;
  height: 26%;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-weight: bold;
    text-align: center;
    line-height: 13px;
  }
`

const SexDiv = styled.div`
  position: absolute;
  top: 29%;
  left: 31.5%;
  font-size: 30px;
  font-weight: bold;
`

const Device0 = styled.div`
  position: absolute;
  top: 72.5%;
  left: 30%;
  border: solid 2px;
  border-radius: 50%;
  width: 32px;
  height: 32px;
`
const Device2 = styled(Device0)`
  left: 35.5%;
`
const Device4 = styled(Device0)`
  left: 44%;
`

const VCOk = styled.div`
  position: absolute;
  top: 71.5%;
  left: 8.5%;
  border: solid 2px;
  border-radius: 50%;
  width: 18px;
  height: 18px;
`

const VCNg = styled.div`
  position: absolute;
  top: 71.5%;
  left: 13%;
  border: solid 2px;
  border-radius: 50%;
  width: 18px;
  height: 18px;
`

const VCCaseBy = styled.div`
  position: absolute;
  top: 71.5%;
  border: solid 2px;
  border-radius: 50%;
  width: 8%;
  height: 8%;
  left: 18%;
`

const VCBase = styled.div`
  position: absolute;
  top: 78.5%;
  border: solid 2px;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  left: 8%;
`
const VCLine = styled(VCBase)``

const VCSkype = styled(VCBase)`
  left: 19.5%;
`

const VCDiscord = styled(VCBase)`
  left: 13.5%;
`

const PlayStyleBeginner = styled.div`
  position: absolute;
  top: 29%;
  left: 48%;
  border: solid 2px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
`

const PlayStyleSerious = styled.div`
  position: absolute;
  top: 38.5%;
  left: 48%;
  border: solid 3px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
`

const PlayStyleEnjoy = styled.div`
  position: absolute;
  top: 47.5%;
  left: 48%;
  border: solid 3px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
`
